export const cutWalletName = (wallet: string | undefined, len: number = 3) => {
  if (!wallet) return ""

  return wallet.slice(0, len) + "..." + wallet.slice(wallet.length - len)
}
